import { createContext, useState, useContext } from "react";

const LanguageContext = createContext();

export const useLanguageCtx = () => {
  return useContext(LanguageContext);
}

export const LanguageContextProvider = ({children}) => {
  const [language, setLanguage] = useState("spanish")

  const spanishLanguage = () => setLanguage("spanish");
  const englishLanguage = () => setLanguage("english");

  const context = {
    language,
    setSpanishLanguage: spanishLanguage,
    setEnglishLanguage: englishLanguage
  }

  return (
    <LanguageContext.Provider value={context}>
      {children}
    </LanguageContext.Provider>
  )
};